import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { ModelInterface, ReportModelInterface, SubtypeInterface } from 'src/app/util/interfaces/manufacturer';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class ModelService {
	private postModelsURL = environment.baseApiUrl + 'manufacturer/createModel';
	private getAllModelsURL = environment.baseApiUrl + 'manufacturer/searchModel';
	private updateModelsURL = environment.baseApiUrl + 'manufacturer/updateModel/{id}';
	private deleteModelsURL = environment.baseApiUrl + 'manufacturer/inactiveModels';
	private activeModelsURL = environment.baseApiUrl + 'manufacturer/activeModels';
	private getAllCiTypeURL = environment.baseApiUrl + 'manufacturer/searchCiType';
	private getAllSubtypesURL = environment.baseApiUrl + 'manufacturer/searchSubtypes';
	private getReportModelURL = environment.baseApiUrl + 'manufacturer/reportModel';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllModels(): Observable<ModelInterface[]> {
		return this.httpClient.get<any[]>(this.getAllModelsURL, { headers: this.headers }).pipe(
			map((modelArray: ModelInterface[]) => {
				for (const model of modelArray) {
					model['icon'] = model.version == 'Manualmente' ? 'faPencil' : 'faLock';
				}

				return modelArray;
			})
		);
	}

	getModelByID(id: string): Observable<ModelInterface> {
		const getModelByIdURL = this.getAllModelsURL + '?id=' + id;
		return this.httpClient.get<any>(getModelByIdURL, { headers: this.headers }).pipe(
			map((interfaceById) => {
				interfaceById = interfaceById[0];
				const newInterface: ModelInterface = {
					id: interfaceById.id,
					manufacturer: interfaceById.manufacturer,
					model: interfaceById.model,
					type: interfaceById.type,
					subtype: interfaceById.subtype,
					active: interfaceById.active,
					release_date: interfaceById.release_date,
					version: interfaceById.version,
					customer: interfaceById.customer,
					name_manufacturer: interfaceById.name_manufacturer,
					label_ct: interfaceById.label_ct,
					label_cs: interfaceById.label_cs,
					message: interfaceById.message,
				};
				return newInterface;
			}),
			catchError((error) => {
				throw error;
			})
		);
	}

	postModel(model: ModelInterface): Observable<any> {
		const body = {
			manufacturer: model.manufacturer,
			model: model.model,
			type: model.type,
			subtype: model.subtype,
			active: model.active,
			release_date: model.release_date,
			version: model.version,
			customer: model.customer,
			message: model.message,
		};
		return this.httpClient.post(this.postModelsURL, body, { headers: this.headers });
	}

	updateModel(customInterface: ModelInterface): Observable<any> {
		const updateModelsURL = this.updateModelsURL.replace('{id}', customInterface.id);
		const body = {
			manufacturer: customInterface.manufacturer,
			model: customInterface.model,
			type: customInterface.type,
			subtype: customInterface.subtype,
			active: customInterface.active,
			release_date: customInterface.release_date,
			version: customInterface.version,
			customer: customInterface.customer,
			message: customInterface.message,
		};
		return this.httpClient.put(updateModelsURL, body, { headers: this.headers });
	}

	deleteModel(customInterface: number[], message: string): Observable<any> {
		const deleteModelURL = this.deleteModelsURL;
		const requestBody = { ids: customInterface, message: message };

		return this.httpClient.put<any>(deleteModelURL, requestBody, { headers: this.headers });
	}

	activeModel(customInterface: number[], message: string): Observable<any> {
		const activeModelURL = this.activeModelsURL;
		const requestBody = { ids: customInterface, message: message };

		return this.httpClient.put<any>(activeModelURL, requestBody, { headers: this.headers });
	}

	getAllCiType(): Observable<ciTypesInterface[]> {
		return this.httpClient.get<any[]>(this.getAllCiTypeURL, {
			headers: this.headers,
		});
	}

	getAllSubtypes(): Observable<SubtypeInterface[]> {
		return this.httpClient.get<any[]>(this.getAllSubtypesURL, {
			headers: this.headers,
		});
	}

	getSubtypesByCiType(id: string): Observable<SubtypeInterface[]> {
		const getAllSubtypeURL = this.getAllSubtypesURL + '?ci_type=' + id;
		return this.httpClient.get<SubtypeInterface[]>(getAllSubtypeURL, {
			headers: this.headers,
		});
	}

	getReportModel(id: number): Observable<ReportModelInterface[]> {
		const getReportModelURL = this.getReportModelURL + '?id_model=' + id;
		return this.httpClient.get<ReportModelInterface[]>(getReportModelURL, {
			headers: this.headers,
		});
	}
}
